/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Name_PlaceholderInputs */

const en_ui_studio_name_placeholder = /** @type {(inputs: Ui_Studio_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Route name`)
};

const de_ui_studio_name_placeholder = /** @type {(inputs: Ui_Studio_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Route`)
};

/**
* | output |
* | --- |
* | "Route name" |
*
* @param {Ui_Studio_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_name_placeholder = /** @type {((inputs?: Ui_Studio_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_name_placeholder(inputs)
	return de_ui_studio_name_placeholder(inputs)
});